import React from "react"
import { UserProvider } from "./src/utils/closedArea/UserContext"

export const wrapRootElement = ({ element }) => {
  return <UserProvider>{element}</UserProvider>
}
